import { makeAutoObservable } from "mobx"
import AdditionalTesting from "../api/models/addOnTesting/AdditionalTesting"

export default class AdditionalTestingStore {
  additionalTesting?: AdditionalTesting
  showCart?: boolean

  constructor() {
    makeAutoObservable(this)
  }

  setAdditionalTesting(value: AdditionalTesting | undefined) {
    this.additionalTesting = value
  }

  setShowCart(value: boolean){
    this.showCart = value
  }
}
